import config from '../../../../../../../../../../../../../../../config'

export const localeSelector = (state) => state.getIn(['translate', 'locale'])
export const tokenSelector = (state, id) =>
    state.getIn(['ui', 'modules', config.modules.report.key, 'workspace', id, 'token'], null)
export const customDataSelector = (state, id) =>
    state.getIn(
        [
            'ui',
            'workspace',
            config.modules.report.key,
            id,
            'blocks',
            config.modules.report.blocks.estates.key,
            'customData',
        ],
        {}
    )
